import React,{useState, useEffect} from 'react'
import { Link } from 'react-router-dom'

export default function ScrollToTop() {
    let [scrolling, setScrolling] = useState(false);

    useEffect(()=>{

        const handleScroll = () => {
            const isScrolling = window.scrollY > 50;
            setScrolling(isScrolling);
        };
        window.addEventListener('scroll', handleScroll);

        return()=>{
            window.removeEventListener('scroll', handleScroll);
        }
        
    },[])

    const scrollToTop = () =>{ 
        window.scrollTo({ 
          top: 0,  
          behavior: 'smooth'
          /* you can also use 'auto' behaviour 
             in place of 'smooth' */
        }); 
      }; 

  return (
    <Link href="#" onClick={()=>scrollToTop()} className="back-to-top rounded text-center" id="back-to-top" style={{display: scrolling ? 'block' : 'none'}}> 
        <i className="mdi mdi-chevron-up d-block"> </i> 
    </Link>
  )
}
